

































// Vue
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

// components
import vSelect from 'vue-select'

// models
import { PropOptionSelect } from '@/models'

@Component({
  name: 'Select2',
  components: {
      vSelect
  }
})
export default class Select2 extends Vue {
	@Prop() readonly label!: string
	@Prop({ default: false }) readonly required!: boolean
	@Prop({ default: '' }) readonly id!: string | number
	@Prop({ default: '' }) readonly name!: string
	@Prop({ default: '' }) readonly className!: string
	@Prop({ default: '' }) readonly iconClass!: string
	@Prop({ default: '' }) readonly default!: string
	@Prop({ default: '' }) readonly msgError!: string
	@Prop({ default: null }) readonly hasError!: boolean|null
    @Prop({ default: false }) readonly reduce!: boolean
    @Prop({ default: false }) readonly multiple!: boolean
    @Prop({ default: false }) readonly taggable!: boolean
    @Prop({ default: false }) readonly disabled!: boolean
    @Prop({ default: false }) readonly appendToBody!: boolean
	@Prop({ required: true }) readonly options!: PropOptionSelect[]

	value: string|null = this.default

    input () {
        this.$emit('change', this.value)
        this.$emit('input', this.value)
    }

    @Watch('default', { immediate: true, deep: true })
    changeOptions (newValue: string, oldValue: string) {
        if (newValue !== oldValue) {
            this.value = this.default
            this.input()
        }
    }
}
